import defaultFetch from 'isomorphic-unfetch';
import { createCustomError } from '@/scopes/common/infrastructure/logging/create-custom-error';
import type { ApiResponse } from '@/scopes/products/user-reviews/infrastructure/api/translations/types';

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string;
  };
  fetch: typeof defaultFetch;
}

export const TranslationAPISystemError = createCustomError('TranslationAPISystemError');

export const createTranslationAPIClient = (dependencies: Partial<Dependencies> = {}) => {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
  } = dependencies as Dependencies;
  async function translate(inputString: string): Promise<string> {
    const url = `${env.NEXT_PUBLIC_API_BASE_URL}/TranslationsApi/GetTranslation`;

    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ text: inputString }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new TranslationAPISystemError('Unable to fetch translation from API');
    }

    const { text }: ApiResponse = await response.json();

    return text;
  }

  return { translate };
};
